import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link as RouterLink } from 'react-router-dom';
import cx from 'classnames';

import styles from './styles.css';

const Link = ({
  activeOnlyWhenExact,
  children,
  className,
  isButton,
  label,
  onClick,
  to,
}) => {
  const linkClasses = cx(
    {
      [styles.link]: true,
      [styles.linkIsButton]: isButton,
    },
    className
  );

  return (
    <Route
      path={to}
      exact={activeOnlyWhenExact}
      children={() => (
        <RouterLink to={to} className={linkClasses} onClick={onClick}>
          {label && <span className={styles.linkLabel}>{label}</span>}
          {children && children}
        </RouterLink>
      )}
    />
  );
};

Link.propTypes = {
  activeOnlyWhenExact: PropTypes.bool,
  className: PropTypes.string,
  navLabel: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/index.js